export function getDDD(phone) {
  const cleanedPhone = phone.replace(/[^\d]/g, '');

  if (cleanedPhone.length < 10) {
    return '';
  }

  const ddd = cleanedPhone.substring(0, 2);

  return ddd;
}
